import { useSnackbar } from "notistack"
import { useEffect, useState } from "react"
import CaixaContext from "../../contexts/caixaContext"

import { buscarCaixa, obterCaixasAbertos } from "../../services/controlecaixa"
import { buscarestabelecimentos } from "../../services/integracao"

import { RegistrarLogErro, salvarPermissoesCaixaFornecedor } from "../../services/clientefiel"

import ModalCaixa from "./modalCaixa"
import MostrarCaixas from "./MostrarCaixas"

import { useMediaQuery } from "@material-ui/core"
import Container from "@material-ui/core/Container"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import useAppStore from "../../stores/AppStore"
import useLoadingStore from "../../stores/LoadingStore"

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 999999,
        color: "#fff",
    },

    divChip: {
        marginBottom: "1em",
        textAlign: "center",
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    tipo: {
        display: "flex",
        flexDirection: "column",
    },
    appContainer: {
        paddingTop: "6em",
        backgroundColor: "#f4f4f4",
    },
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    appBar: {
        position: "fixed",
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    trocarEstabelecimento: {
        marginTop: "1em",
        textAlign: "center",
    },

    list: {
        width: "100%",
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
}))

export default function Caixa() {
    const configuracoes = useAppStore(s => s.configuracoes)
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("md"))
    const autorizacao = localStorage.getItem("chaveSistema")

    const setLoading = useLoadingStore(s => s.setLoading)
    const { enqueueSnackbar } = useSnackbar()
    const [caixaSelecionada, setCaixaSelecionada] = useState({})
    //DECLARAÇÃO DE VARIÁVEIS

    const [estabelecimentos, setEstabelecimentos] = useState([])
    const [estabelecimentoSelecionado, setEstabelecimentoSelecionado] = useState({}) //quando clicar no estabelecimento
    const [caixasAbertos, setCaixasAbertos] = useState([]) //quando clicar no caixa

    useEffect(() => {
        handleBuscarDadosEstabelecimentos()
        salvarPermissoesCaixa()
    }, [])

    const salvarPermissoesCaixa = async () => {
        try {
            setLoading(true)
            const response = await salvarPermissoesCaixaFornecedor(
                configuracoes.user.id,
                autorizacao
            )
        } catch (error) {
            RegistrarLogErro(error, "salvarPermissoesCaixaFornecedor")
        }
    }

    const handleBuscarDadosEstabelecimentos = async () => {
        try {
            setLoading(true)

            const response = await buscarestabelecimentos(autorizacao)
            if (response.retornoErro) {
                return enqueueSnackbar(response.mensagem, { variant: "error" })
            }

            const estabelecimentoLocal = response.filter(
                e => e.id === configuracoes?.user?.parametros?.estabelecimento.id
            )[0]

            if (response.length === 1) {
                setEstabelecimentoSelecionado(response[0])
                handleBuscarCaixasAbertos(response[0])
            } else if (response.length > 1) {
                handleBuscarCaixasAbertos(estabelecimentoLocal)
                setEstabelecimentoSelecionado(estabelecimentoLocal)
            }

            setEstabelecimentos(response)
        } catch (error) {
            RegistrarLogErro(error, "handleBuscarDadosEstabelecimentos")
        } finally {
            setLoading(false)
        }
    }

    const handleBuscarCaixasAbertos = async estabelecimento => {
        try {
            setLoading(true)
            setEstabelecimentoSelecionado(estabelecimento)
            const caixasAbertosRetorno = await obterCaixasAbertos(estabelecimento.id, autorizacao)
            console.log("---Caixas Abertos--", caixasAbertosRetorno)
            if (caixasAbertosRetorno.status >= 300) {
                enqueueSnackbar(caixasAbertosRetorno.message, { variant: "error" })
            } else {
                if (caixasAbertosRetorno.response.length === 0) {
                    enqueueSnackbar("Nenhum caixa foi encontrado.", { variant: "warning" })
                }
                setCaixasAbertos(caixasAbertosRetorno.response)
            }
        } catch (error) {
            RegistrarLogErro(error, "handleBuscarDadosEstabelecimentos")
        }
        setLoading(false)
    }

    const handleBuscarCaixa = async idCaixa => {
        try {
            setLoading(true)
            const buscarCaixaResponse = await buscarCaixa(idCaixa, autorizacao)
            console.log("---Buscar Caixa--", buscarCaixaResponse)
            if (buscarCaixaResponse.status >= 300) {
                enqueueSnackbar(buscarCaixaResponse.message, { variant: "error" })
            } else {
                setCaixaSelecionada(buscarCaixaResponse.response)
            }
        } catch (error) {
            RegistrarLogErro(error, "handleBuscarCaixa")
        }
        setLoading(false)
    }

    //HTML

    return (
        <CaixaContext.Provider
            value={{
                caixaSelecionada,
                setCaixaSelecionada,
                handleBuscarCaixa,
                handleBuscarCaixasAbertos,
                estabelecimentos,
                estabelecimentoSelecionado,
                caixasAbertos,
                setCaixasAbertos,
            }}
        >
            <Container
                component="main"
                style={{ marginTop: "4em", paddingLeft: mobile ? "" : "80px" }}
                className="container-buscando"
            >
                <MostrarCaixas />

                {caixaSelecionada.id && <ModalCaixa />}
            </Container>
        </CaixaContext.Provider>
    )
}
